import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  Paper,
  Checkbox,
  IconButton,
  TextField,
  MenuItem,
  Backdrop,
  Button,
  CircularProgress,
  Popover,
  Skeleton,
  ListItemText,
  Autocomplete,
  Tooltip,
  useMediaQuery,
  Stack,
  Fade,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import {
  Add,
  ArrowCircleRight,
  Clear,
  CloudDownload,
  CloudUpload,
  Download,
  Edit,
  EditOff,
  MarkEmailUnread,
  MoreVert,
  Print,
  Share,
} from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import { useDispatch } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import { MoneyFormatv3 } from '../../library/MoneyFormat';
import { API, graphqlOperation } from 'aws-amplify';
import DeleteInvoice from '../../components/modals/DeleteInvoiceMaster';
import { useNavigate } from 'react-router-dom';
import DeletedSelectedInvoice from '../../components/modals/DeletedSelectedInvoice';
import DropDownForListing from '../../components/DropDown/DropDown';
import CancelInvoice from '../../components/modals/CancelInvoice';
import { ClearIcon } from '@mui/x-date-pickers';
import { updateTitle, updateViewTitle } from '../../redux/reducers/titleSlice';
import CustomDate from '../../components/Date/CustomDate';
import dayjs from 'dayjs';
import { useWarningModal } from '../../components/modals/AddUnits';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import PeriodDropDown from '../../components/DropDown/PeriodDropDown';
import {
  checkandopenpdf,
  defaultRowsPerPage,
  defaultRowsPerPageOptions,
  fetchAndPrintPDF,
  getDefaultSorting,
  handleFreeze,
} from '../../utils/common';
import MoneyRanger from '../../components/formElements/MoneyRanger';
import { ShareModal } from '../../components/modals/Share';
import { useLambdaFunctionUrl } from '../../hooks/useEmailSettingLambda';
import { einvAuth, einvAuthData, einvId, einvPreview } from '../../redux/reducers/eInvReducer';
import { axiosInstanceForLambda } from '../../library/Axios';
import { useThemes } from '../../components/Theme/theme';
import EInvoiceCancel from '../../components/modals/eInvoiceCancel';
import {
  getPartyAddressEinv,
  getPartyAddressEntity,
  getPartyAddressEway,
  listInvoiceMasterCount,
  listInvoiceMasterv2Custom,
} from '../../graphql';
import { useCreatePdfMutation } from '../../redux/apis/createPdf.api';
import EInvAuth from '../PrimeFigma/Modals/EInvAuth';
import { TableCell } from '../../components/Table/TableCell';
import { LedgerTransactionModalv2 } from '../LedgerTransaction/TransactionsModal';
import API_ENDPOINTS from '../../apiEndpoints';
import { formatUnixTimestamp, addDaysToDate } from '../../library/dayJs';
import { createDebouncedCallback } from '../../hooks/createDebouncedCallback';
import pdfImage from '../../assets/images/attachments/pdf.png';
import { IS_LOCAL } from '../../config';
import TableSearchButton from '../PrimeFigma/Components/TableSearchButton';
import PreviewSalesTaxable from '../../components/modals/PreviewSalesTaxable';
import { SendEmailModalWrapper, useSendEmailModal } from '../../features/Email';
import RollingSoon from '../../components/Ui/RollingSoon';
import { DateRangeRsuite, MoneyTextFieldRange } from '../../components';
import { handleEwaybillValidation } from '../../utils/ewaybillValidation';
import TimeLeftComp from './timeLeftComp';
import { useFetchOpeningBalanceDateQuery } from '../../redux/apis/openingbalacedate.api';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
// here
// Invoice Table Headcells  //
const invoiceHeadCells = [
  {
    id: 'InvoiceDate',
    numeric: false,
    disablePadding: true,
    label: 'Date',
    width: '200px',
    search: true,
  },
  {
    id: 'InvoiceNumber',
    numeric: false,
    disablePadding: false,
    label: 'Invoice#',
    width: '200px',
    search: true,
  },
  {
    id: 'partyName',
    numeric: false,
    disablePadding: false,
    label: 'Customer Name',
    width: '170px',
    search: true,
  },
  {
    id: 'InvoiceAmount',
    numeric: true,
    disablePadding: false,
    label: 'Invoice Amount (₹)',
    width: '150px',
    search: true,
  },
  {
    id: 'balancedueamount',
    numeric: true,
    disablePadding: false,
    label: 'Inv. Net Due (₹)',
    width: '115px',
  },
  {
    id: 'dueDate',
    numeric: false,
    disablePadding: false,
    label: 'Due Date',
    width: '150px',
    search: true,
  },
  {
    id: 'overDueDays',
    numeric: true,
    disablePadding: false,
    label: 'Due in/Over Due',
    width: '150px',
    search: true,
  },

  {
    id: 'statusCD',
    numeric: false,
    disablePadding: false,
    label: 'Status',
    width: '100px',
    search: true,
    disableSort: true,
  },
  {
    id: 'E-Invoice',
    numeric: false,
    disablePadding: false,
    label: 'E-Invoice',
    width: '100px',
    search: false,
    disableSort: true,
  },
  // {
  //   id: 'Cancel E-Invoice',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'Cancel E-Invoice',
  //   width: '110px',
  //   search: false,
  //   disableSort: true,
  // },
  {
    id: 'E-way bill',
    numeric: false,
    disablePadding: false,
    label: 'E way bill',
    width: '100px',
    search: false,
    disableSort: true,
  },
  {
    id: 'Cancel E-way bill',
    numeric: false,
    // disablePadding: true,
    label: '',
    width: '8px',
    search: false,
    disableSort: true,
  },
  // {
  //   id: 'E-way bill status',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'E-way bill status',
  //   width: '110px',
  //   search: false,
  //   disableSort: true,
  // },
  // {
  //   id: "BalanceDueAmount",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Balance Due",
  //   width: "100px",
  // },
  // {
  //   id: "Action",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Actions",
  //   width: "80px",
  //   search: false,
  //   disableSort: true,
  // },
  {
    id: 'Action',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    width: '120px',
    search: true,
    // disableSort: true,
  },
  {
    id: '',
    numeric: false,
    disablePadding: false,
    label: '',
    width: '130px',
    search: false,
    disableSort: true,
  },
  // {
  //   id: "actions",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Actions",
  //   width: "80px",
  //   search: false
  // },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCell,
    onDelete,
    setEnableSearch,
    getCompany,
    rowList,
    visiblerowlength,
    setShowActions,
    showActions,
    scroll,
  } = props;
  const { theme } = useThemes();
  const smalldevices = useMediaQuery('(max-width:480px)');
  function overDueFunction(label) {
    const [beforeSlash, afterSlash] = label.split('/');

    return (
      <span>
        <span style={{ color: 'green' }}>{beforeSlash}/</span>
        <span style={{ color: 'red' }}>{afterSlash}</span>
      </span>
    );
  }
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow
        sx={{
          '.MuiTableCell-root': {
            backgroundColor: `${theme.palette.background.tablebg} !important`,
            fontSize: '14px',
            padding: '0px',
            '& .MuiCheckbox-root': {
              padding: '4px',
            },
          },
          '.MuiTableCell-head': {
            backgroundColor: 'background.tablebg',
            padding: '2px 10px',
            borderBottom: '0px',
          },
          height: '35px',
        }}
      >
        <TableCell
        // padding="checkbox"
        // sx={{
        //   ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root": {
        //     padding: "5px",
        //   },
        // }}
        >
          <Checkbox
            sx={{ color: 'input.border' }}
            indeterminate={numSelected > 0 && numSelected < visiblerowlength}
            checked={numSelected === visiblerowlength && visiblerowlength !== 0}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
            size="small"
          />
        </TableCell>
        {headCell.map((headCell) => (
          <TableCell
            id={headCell.id === 'Action' ? 'action' : ''}
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              display:
                headCell.id == 'E-Invoice'
                  ? getCompany?.relatedcompanydetailsnew?.[0].einvoiceflag == 1
                    ? ''
                    : 'none'
                  : headCell.id == 'E-way bill' || headCell.id == 'Cancel E-way bill'
                  ? getCompany?.relatedcompanydetailsnew?.[0].ewaybillflag == 1
                    ? ''
                    : 'none'
                  : '',
              minWidth: rowList > 0 ? headCell.width : 'auto',
              maxWidth: rowList > 0 ? 'auto' : headCell.width,
              position: headCell.id === 'Action' ? 'sticky' : '',
              right: headCell.id === 'Action' ? 0 : '',
              // borderLeft: headCell.id === "Action" ? "1px solid" : "0px",
            }}
            // sx={{minWidth:headCell.width}}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: headCell.id === 'Action' ? 'center' : 'space-between',
                alignItems: 'center',
                flexDirection: headCell.numeric ? 'row-reverse' : '',
                // border: headCell.id === "Action" ? "1px solid black" : "",
                borderRadius: headCell.id === 'Action' ? '3px' : '',
                width: '100%',
                backgroundColor: headCell.id === 'Action' ? 'white' : 'background.tablebg',
                boxShadow: headCell.id === 'Action' && scroll ? '0px 4px 8px rgba(0, 0, 0, 0.6)' : '',
                '&:active': {
                  transform: scroll ? 'scale(0.92)' : 'scale(1)',
                },
              }}
              onClick={(e) => {
                if (headCell.label === 'Actions') {
                  setShowActions((pre) => !pre);
                }
              }}
            >
              <TableSortLabel
                active={
                  orderBy === headCell.id
                    ? true
                    : 'dueDate' === headCell.id && orderBy === 'dueDateTimeStamp'
                    ? true
                    : 'InvoiceDate' === headCell.id && orderBy === 'InvoiceDateTimeStamp'
                    ? true
                    : false
                }
                direction={orderBy === 'dueDateTimeStamp' || 'InvoiceDateTimeStamp' ? order : orderBy === headCell.id ? order : 'asc'}
                onClick={headCell.id == 'Action' || headCell.disableSort ? null : createSortHandler(headCell.id)}
                hideSortIcon={headCell.id === 'Action' || headCell.disableSort}
                sx={{
                  '& .MuiTableSortLabel-icon': {
                    color: '#911B7C',
                  },
                  '&:hover .MuiTableSortLabel-icon': {
                    color: '#bf3ca7ff',
                  },
                  '&.Mui-active .MuiTableSortLabel-icon': {
                    color: '#911B7C',
                  },
                }}
              >
                <Box sx={{ display: 'flex' }}>
                  <Box sx={{ whiteSpace: 'nowrap' }}>
                    {' '}
                    {headCell.id === 'overDueDays' ? overDueFunction(headCell.label) : headCell.label}
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {orderBy === headCell.id ? (
                      <Box
                        //  component="span"
                        sx={visuallyHidden}
                      >
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                      </Box>
                    ) : null}
                    {headCell.search === true &&
                      (headCell.id == 'Action' ? (
                        <ArrowCircleRight
                          sx={{
                            transition: 'transform 0.3s ease-in-out',
                            marginLeft: '10px',
                            transform: scroll ? (!showActions ? 'rotate(0deg)' : 'rotate(180deg)') : '(rotate(180deg))',
                            color: scroll ? (!showActions ? 'gray' : '#ee5b2b') : '#ee5b2b',
                          }}
                          fontSize="small"
                        />
                      ) : // <SearchIcon
                      //   onClick={(e) => {
                      //     e.preventDefault();
                      //     e.stopPropagation();
                      //     setEnableSearch((prev) => !prev);
                      //   }}
                      //   sx={{ marginLeft: "10px" }}
                      //   fontSize="small"
                      // />
                      null)}
                  </Box>
                </Box>
              </TableSortLabel>
            </Box>
          </TableCell>
        ))}

        {/* {numSelected > 0 ? (
          <TableCell>
            <ThreeDot
              onDelete={() => {
                onDelete(true);
              }}
            />
          </TableCell>
        ) : null} */}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function AllSalesInvoices() {
  const { theme } = useThemes();

  const dispatch = useDispatch();
  dispatch(display());
  const navigate = useNavigate();
  let location = useLocation();
  const firstMount = useRef(true);
  const debouncedSearchRef = useRef(null);
  useEffect(() => {
    dispatch(einvPreview({ preview: false, id: 0 }));
  }, []);
  // at component top
  const timeleftref = useRef({}); // ✅ not null

  const getRef = (id) => {
    if (!timeleftref.current) timeleftref.current = {}; // extra safety
    if (id == null) return React.createRef(); // guard bad ids
    if (!timeleftref.current[id]) timeleftref.current[id] = React.createRef();
    return timeleftref.current[id];
  };
  const [salesTableState, setSalesTableState] = useState('invoice');
  const { defaultSortingColumn, defaultSortingOrder } = getDefaultSorting('sales');
  const [order, setOrder] = useState(defaultSortingOrder);
  const [orderBy, setOrderBy] = useState(defaultSortingColumn);

  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [cancelModalStatus, setCancelModalStatus] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [invoiceRows, setInvoiceROws] = useState([]);
  console.log({ invoiceRows }, 'invoiceRows');
  const [circularOpen, setCircularOpen] = useState(true);
  const [rowData, setRowData] = useState({});
  // const [filteredList, setFilteredList] = useState([]);
  const [deleteSelectedModal, setDeleteSelectedModal] = useState(false);
  const [partyDetails, setPartyDetails] = useState([]);
  const [dataCount, setdataCount] = useState(0);
  const defaultFilterColumns = {
    date: '',
    InvoiceNumber: '',
    CustomerName: '',
    dueDate: '',
    Status: '',
    BalanceDue: '',
    InvoiceAmount: '',
    AmountFrom: '',
    AmountTo: '',
    BalanceDueAmount: '',
    balancedueamountfrom: '',
    balancedueamountto: '',
    DueDateTo: '',
    DueDateFrom: '',
    InvoiceDateTo: '',
    InvoiceDateFrom: '',
    OverDueDays: '',
  };
  const [filterColumns, setFilterColumns] = useState(defaultFilterColumns);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [showActions, setShowActions] = useState(true);

  console.log(filterColumns.InvoiceDateFrom, '****from', filterColumns.InvoiceDateTo, '*****to');

  const handleResetFilterColumns = (status) => {
    if (status === false) {
      setFilterColumns(defaultFilterColumns);
      clearEmailSelection();
      setSelected([]);
    }
  };

  const [gstStatus, setGstStatus] = useState('');
  const [backdropOpen, setBackdropOpen] = useState(false);
  let [searchParams, setSearchParams] = useSearchParams();
  let active = searchParams.get('active');
  const [companyDetails, setCOmpanyDetails] = useState([]);
  const [cancelEOpen, setCancelEOpen] = useState(false);

  const [exportItem, setExportItem] = useState(null);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [itemData, setItemData] = useState({});
  const [cancelEInv, setCancelEInv] = useState(false);
  const [connectCheckbox, setConnectCheckbox] = useState('');
  const [cancelEInvState, setCancelEInvState] = useState({
    reason: '',
    remark: '',
    errorStatus: {
      reason: false,
      remark: false,
    },
  });
 const [exportStartDate,setExportStartDate] = useState('');

  const { data: openingBalanceDate, isLoading } = useFetchOpeningBalanceDateQuery(
      {
        invoicetypecd: 'Sales',
        invoiceid: 0,
      },
      {
        refetchOnMountOrArgChange: true,
      }
    );
    const obDate = dayjs(openingBalanceDate?.getMinMaxInvoiceDate?.openingbalancedate).unix();
    useEffect(() => {
      if(startDate > obDate ){
        setExportStartDate(startDate);
      }else{
        setExportStartDate(obDate);
      }
    },[obDate,startDate]);

  // Function to calculate time left for cancel button based on diff (hours elapsed)
  const calculateTimeLeft = (diff) => {
    if (diff >= 24) return '';

    const hoursLeft = 24 - diff;
    const hours = Math.floor(hoursLeft);
    const minutes = Math.floor((hoursLeft - hours) * 60);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };

  // Real-time timer for updating time displays without re-rendering
  const updateTimeDisplays = () => {
    const timeElements = document.querySelectorAll('[data-time-left]');
    timeElements.forEach((element) => {
      const originalDiff = parseFloat(element.getAttribute('data-diff'));
      const createdAt = parseFloat(element.getAttribute('data-created-at'));

      // Recalculate current diff based on current time
      let currentDiff = originalDiff;
      if (createdAt) {
        const now = Date.now();
        const createdTime = createdAt * 1000; // Convert from seconds to milliseconds
        const timeDiff = now - createdTime;
        currentDiff = timeDiff / (1000 * 60 * 60); // Convert to hours
      }

      const timeLeft = calculateTimeLeft(currentDiff);
      if (timeLeft) {
        element.textContent = `(${timeLeft} hrs)`;
        element.style.display = 'inline';
      } else {
        element.style.display = 'none';
      }
    });
  };

  // Start the real-time timer
  useEffect(() => {
    const interval = setInterval(updateTimeDisplays, 60000); // Update every minute
    return () => clearInterval(interval);
  }, []);
  const [anchorEl, setAnchorEl] = useState(null);
  const [action, setAction] = useState('');
  const [actionData, setActionData] = useState({});
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  console.log(userPreferece, '^^^^^');
  const modalRef = useRef();
  const slaeInvoiceTaableRef = useRef(null);
  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/`;
  let prevData = useSelector((state) => state.eInvReducer.data);
  // Click handler for the main box to open the popover
  const getCompany = useSelector((state) => state?.companyReducer.companyDetails);
  const handleClickBox = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  // Click handler to close the popover
  const handleClose = () => {
    setAnchorEl(null);
  };
  // Check if the popover should be open based on anchorEl
  const open = Boolean(anchorEl);
  const einvState = location?.state?.id;
  console.log(einvState, 'einvState');
  let { WarningModal, handleOpen: setWarningOpen } = useWarningModal();

  useEffect(() => {
    if (filterColumns.InvoiceDateFrom && filterColumns.InvoiceDateTo) {
      setStartDate(filterColumns.InvoiceDateFrom);
      setEndDate(filterColumns.InvoiceDateTo);
    } else {
      setStartDate(userPreferece?.financialYear?.startdate);
      setEndDate(userPreferece?.financialYear?.enddate);
    }
  }, [filterColumns, userPreferece]);

  // Options to display in the popover, each with a label and onClick handler
  const options = [
    // {
    //   label: 'Import',
    //   icon: <CloudDownload sx={{ color: 'blue' }} />,
    //   onClick: () => {},
    //   link: '/import-data?',
    //   rollingOutSoon: true
    // },
    {
      label: 'Export',
      icon: <CloudUpload sx={{ color: '#ffa500' }} />,
      onClick: () => {
        // if (invoiceRows.length > 0) {
        //   setExportModalOpen(true);
        //   setExportItem('INVOICE');
        // } else {
        //   showWarningSnackbar('No data available for export.');
        // }
        // const to = `/exports/sales?startDate=${startDate}&endDate=${endDate}`
        // navigate('/');
      },
      link: `/exports/sales?startDate=${exportStartDate}&endDate=${endDate}`,
    },

    {
      label: 'Send Selected Invoices',
      icon: <MarkEmailUnread />,
      onClick: () => {
        handleBulkEmail();
      },
      link: '',
    },
    // {
    //   label: "Download",
    //   icon: <Download />,
    //   onClick: () => {
    //     handleBulkDownload();
    //   },
    //   link: "",
    // },
  ];

  const handleRequestSort = (event, property) => {
    let isAsc = orderBy === property && order === 'asc';
    if (property === 'dueDate') {
      isAsc = order === 'asc' ? true : false;
      setOrderBy('dueDateTimeStamp');
    } else if (property === 'InvoiceDate') {
      setOrderBy('InvoiceDateTimeStamp');
      isAsc = order === 'asc' ? true : false;
    } else {
      setOrderBy(property);
    }
    setOrder(isAsc ? 'desc' : 'asc');
  };

  const { openModal, modalProps } = useSendEmailModal();

  const handleBulkEmail = () => {
    if (Freeze === 1) {
      return handleFreeze();
    }
    if (emailSendingSelection.length > 0) {
      openModal(
        'salesInvoice',
        emailSendingSelection.map((inv) => ({
          id: Number(inv.invoiceid),
          recipientId: Number(inv.PartyID),
          email: inv.Email,
          name: inv.PartyDisplayName,
          invoiceNumber: inv.invoicenumber,
        }))
      );
    } else {
      showWarningSnackbar("No Invoice's selected. Please select at least one Invoice to send the email.");
    }
    setShareOpen(false);
  };

  // Function to explicitly clear email selection
  const clearEmailSelection = () => {
    setEmailSendingSelection([]);
    setIndividualEmailSelection([]);
  };

  const handleBulkDownload = () => {
    if (selected.length > 0) {
      selected.forEach((e, index) => {
        setTimeout(() => {
          const link = document.createElement('a');
          const url = e.pdflink;
          link.href = url;
          // link.target = "_blank"; // Optional: open in a new tab, useful for large files
          link.download = url; // Optional: specify download filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }, index * 1000);
      });
    } else {
      showWarningSnackbar("No Invoice's selected. Please select at least one Invoice to Download.");
    }
  };

  let handleInputChange = useCallback((name, value) => {
    // const { name, value } = e.target;

    let errorStatus = value ? false : true;

    setCancelEInvState((prevState) => {
      return {
        ...prevState,
        [name]: value,
        // errorFields: {
        //     ...prevState.errorFields,
        //     reason: newReason.length < 5 ? 'Reason is too short' : ''
        // },
        errorStatus: {
          ...prevState.errorStatus,
          [name]: errorStatus,
        },
      };
    });
  }, []);

  const handleEINVBlur = (name) => {
    if (name === 'remark') {
      setCancelEInvState((prevState) => ({
        ...prevState,
        errorStatus: {
          ...prevState.errorStatus,
          [name]: cancelEInvState[name]?.trim() === '',
        },
      }));
    } else {
      setCancelEInvState((prevState) => ({
        ...prevState,
        errorStatus: {
          ...prevState.errorStatus,
          [name]: cancelEInvState[name] === '',
        },
      }));
    }
  };
  console.log(getCompany, 'getCompany');
  // const handleEInvoice = async (e, id) => {
  //   e.stopPropagation();
  //   e.preventDefault();
  //   setConnectCheckbox("invoice");
  //   if (Freeze == 1) {
  //     e.preventDefault();
  //     return handleFreeze();
  //   }

  //   if (getCompany.relatedcompanydetailsnew[0].einvoiceconnect == 0) {
  //     dispatch(einvAuth(true));
  //   }
  //   dispatch(einvPreview({ preview: true, id }));
  //   navigate("/editnewinvoicetax", {
  //     state: { id, connect: "invoice" },
  //   });
  //   // const payload = {
  //   //   action: "authenticate",
  //   // };
  //   // try {
  //   //   const res = await axiosInstanceForLambda.post(
  //   //     import.meta.env.VITE_EINVOICE_URL,
  //   //     payload
  //   //   );
  //   //   console.log(res.data, "data");
  //   // } catch (error) {
  //   //   console.log(error, "error");

  //   //   const parsedMessage = error?.response.data.message;
  //   //   // const errorMessage = parsedMessage.split("ERROR: ")[1].split(";")[0];
  //   //   console.log(parsedMessage, "parsedMessage");
  //   //   if (parsedMessage) {
  //   //     navigate("/editnewinvoicetax", {
  //   //       state: { id },
  //   //     });
  //   //     dispatch(einvAuth(true));
  //   //     showWarningSnackbar(parsedMessage);
  //   //   }
  //   // }
  // };
  const eInvoiceValidate = async () => {
    const payload = {
      action: 'authenticate',
    };
    setBackdropOpen(true);
    try {
      const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EINVOICE_URL, payload);
      return res.data;
    } catch (error) {
      console.log(error, 'error');

      const rawMessage = error?.response?.data?.error || '';
      const parsedMessage = typeof rawMessage !== 'string' ? JSON.parse(rawMessage) : '';
      const errorMessage = parsedMessage ? parsedMessage.ErrorDetails[0].ErrorMessage : null;
      if (errorMessage) {
        showWarningSnackbar(errorMessage);
      }
      setCancelEOpen(true);
    } finally {
      setBackdropOpen(false);
    }
  };
  // const authOk = (id) => {
  //   navigate("/editnewinvoicetax", {
  //     state: { id, eImp: true },
  //   });
  //   // dispatch(eOpen(true));
  //   dispatch(einvId(true));
  //   dispatch(einvPreview({ preview: true, id }));
  // };
  const handleEInvoice = async (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    setConnectCheckbox('invoice');
    if (Freeze == 1) {
      e.preventDefault();
      return handleFreeze();
    }
    const resPartyAddressEntityDetails = await API.graphql(
      graphqlOperation(getPartyAddressEinv, {
        objectid: id,
        objecttype1: 'SalesBilling',
        // objecttype2: 'SalesDelivery',
      })
    );
    // Use utility function for E-way bill validation
    const isValidEway = handleEwaybillValidation(resPartyAddressEntityDetails, showWarningSnackbar, setBackdropOpen, 'Einv');

    if (!isValidEway) {
      return;
    }
    if (getCompany.relatedcompanydetailsnew[0].einvoiceconnect == 1) {
      const test = await eInvoiceValidate();
      console.log(test, 'test');
      if (test === 'success') {
        if (modalRef.current && id) {
          setBackdropOpen(true);
          modalRef.current.triggerCustomAction(id);
          setBackdropOpen(false);
        }
        // navigate("/editnewinvoicetax", {
        //   state: { id, eImp: true },
        // });
        // // dispatch(eOpen(true));
        // dispatch(einvId(true));
        // dispatch(einvPreview({ preview: true, id }));
      } else {
        setCancelEOpen(true);
        dispatch(einvId(false));
        dispatch(einvPreview({ preview: false, id }));
      }
    } else {
      setCancelEOpen(true);
      dispatch(einvId(false));
      dispatch(einvPreview({ preview: false, id }));
    }
    setRowData({
      id: id,
      // nav: "/salesInvoiceReport",
      todo: 'gen',
      // irn: row.irn,

      // from: "E-Invoice",
    });

    // dispatch(eOpen(true));
    // dispatch(einvId(true));
    // dispatch(einvPreview({ preview: true, id }));
    // navigate("/editnewinvoicetax", {
    //   state: { id },
    // });
    // const payload = {
    //   action: "authenticate",
    // };
    // try {
    //   const res = await axiosInstanceForLambda.post(
    //     import.meta.env.VITE_EINVOICE_URL,
    //     payload
    //   );
    //   console.log(res.data, "data");
    // } catch (error) {
    //   console.log(error, "error");

    //   const parsedMessage = error?.response.data.message;
    //   // const errorMessage = parsedMessage.split("ERROR: ")[1].split(";")[0];
    //   console.log(parsedMessage, "parsedMessage");
    //   if (parsedMessage) {
    //     navigate("/editnewinvoicetax", {
    //       state: { id },
    //     });
    //     dispatch(einvAuth(true));
    //     showWarningSnackbar(parsedMessage);
    //   }
    // }
  };

  const eWayValidate = async () => {
    const payload = {
      action: 'authenticate',
    };
    setBackdropOpen(true);
    try {
      const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EWAYBILL_URL, payload);
      return res.data;
    } catch (error) {
      const rawMessage = error?.response.data.error;
      const parsedMessage = JSON.parse(rawMessage);
      const errorMessage = parsedMessage.ErrorDetails[0].ErrorMessage;
      showWarningSnackbar(errorMessage);
      setCancelEOpen(true);
    } finally {
      setBackdropOpen(false);
    }
  };

  const handleCancelEIV = async (row) => {
    setConnectCheckbox('invoice');

    if (getCompany.relatedcompanydetailsnew[0].einvoiceconnect == 1) {
      const test = await eInvoiceValidate();
      if (test === 'success') {
        setCancelEInv(true);
      } else {
        setCancelEOpen(true);
      }
    } else {
      setCancelEOpen(true);
    }
    setRowData({
      id: row.invoiceid,
      nav: '/salesInvoiceReport',
      todo: 'cancel',
      irn: row.irn,

      from: 'E-Invoice',
    });
  };
  const cancelEInvoice = async () => {
    const payload = {
      action: 'cancelIrn',
      InvoiceID: rowData.id,
      data: {
        Irn: rowData.irn,
        CnlRsn: cancelEInvState.reason.toString(),
        CnlRem: cancelEInvState.remark,
      },
      credentials: prevData,
    };

    setBackdropOpen(true);
    try {
      const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EINVOICE_URL, payload);

      if (res.status === 200) {
        showSuccessSnackbar('E-invoice successfully cancelled');

        setInvoiceROws((currentItems) => {
          return currentItems.map((item) => (item.invoiceid === rowData.id ? { ...item, is_cancelled: 1 } : { ...item }));
        });
        setCancelEInv(false);
        if (getCompany.relatedcompanydetailsnew[0].einvoiceconnect == 0) {
          dispatch(
            einvAuthData({
              userName: '',
              password: '',
            })
          );
        }
      }
    } catch (error) {
      console.log(error);
      showWarningSnackbar(error.response.data.details.ErrorDetails[0].ErrorMessage);
    } finally {
      setBackdropOpen(false);
      setCancelEInvState({
        reason: '',
        remark: '',
        errorStatus: {
          reason: false,
          remark: false,
        },
      });
      dispatch(einvAuthData({}));
      dispatch(einvAuth(false));
      dispatch(einvPreview({ preview: false, id: 0 }));
      dispatch(einvId(false));
    }
  };

  const ewayNav = (data) => {
    navigate('/addewaybill', {
      state: {
        invoice: {
          docDate: data.InvoiceDate,
          id: data.invoiceid,
          invoiceNo: data.invoicenumber,
          // irn: data.irn,
          placeofsupply: data.placeofsupply,
          supply: 'O',
          partyId: data.partyid,
          invoiceType: 'SalesInvoice',
        },
        connect: 'invoice',
        from: '/salesInvoiceReport',
        saveNew: false,
      },
    });
  };
  const handleEWaybill = async (e, data) => {
    setAction('geneway');
    e.stopPropagation();
    setConnectCheckbox('eway');
    setBackdropOpen(true);
    try {
      const resPartyAddressEntityDetails = await API.graphql(
        graphqlOperation(getPartyAddressEway, {
          objectid: data.invoiceid,
          objecttype1: 'SalesBilling',
          objecttype2: 'SalesDelivery',
        })
      );
      console.log(resPartyAddressEntityDetails, 'resPartyAddressEntityDetails');

      // Use utility function for E-way bill validation
      const isValidEway = handleEwaybillValidation(resPartyAddressEntityDetails, showWarningSnackbar, setBackdropOpen);

      if (!isValidEway) {
        return;
      }
    } catch (err) {
      console.log(err, 'rrrrr');

      showWarningSnackbar('Something went wrong');
    } finally {
      setBackdropOpen(false);
    }
    if (getCompany.relatedcompanydetailsnew[0].ewaybillconnect == 1) {
      // const test = await eWayValidate();
      // if (test === 'success') {
      ewayNav(data);
      // } else {
      //   setCancelEOpen(true);
      // }
    } else {
      setCancelEOpen(true);
    }
  };

  const handleCancelEWay = async (row) => {
    setConnectCheckbox('eway');
    setAction('caneway');
    if (getCompany.relatedcompanydetailsnew[0].ewaybillconnect == 1) {
      // const test = await eWayValidate();
      // if (test === 'success') {
      setCancelEInv(true);
      //   } else {
      //     setCancelEOpen(true);
      //   }
    } else {
      setCancelEOpen(true);
    }
    setRowData({
      id: row.invoiceid,
      nav: '/salesInvoiceReport',
      todo: 'cancel',
      irn: row.irn,
      billno: row.ewaybillno,
      from: 'E-Way',
    });
  };
  const handleCancelEWaybill = async () => {
    // e.stopPropagation();
    const payload = {
      action: 'CANEWB',
      // credentials: {
      //   userName: 'AL001',
      //   password: 'Alankit@123',
      // Gstin: '07AGAPA5363L002',
      // userName: "Matrix2050",
      // password: "Matrix@2050",
      // Gstin: "33AAHCS2907G1ZK",
      // },
      data: {
        ewbNo: rowData.billno,
        cancelRsnCode: cancelEInvState.reason,
        cancelRmrk: cancelEInvState.remark,
      },
      ...(Object.keys(prevData).length > 0 ? { credentials: prevData } : null),
    };
    setBackdropOpen(true);
    try {
      const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EWAYBILL_URL, payload);
      console.log(res, 'res');
      showSuccessSnackbar('E way bill successfully cancelled');
      setInvoiceROws((currentItems) => {
        return currentItems.map((item) => (item.invoiceid === rowData.id ? { ...item, ewaybill_is_cancelled: 1 } : { ...item }));
      });
      setCancelEInv(false);
      setCancelEInvState({
        reason: '',
        remark: '',
        errorStatus: {
          reason: false,
          remark: false,
        },
      });
      // if (getCompany.relatedcompanydetailsnew[0].einvoiceconnect == 0 || getCompany.relatedcompanydetailsnew[0].ewaybillconnect == 0) {
      //   dispatch(
      //     einvAuthData({
      //       userName: '',
      //       password: '',
      //     })
      //   );
      // }
    } catch (err) {
      console.log(err);
    } finally {
      setBackdropOpen(false);
      dispatch(einvAuthData({}));
      dispatch(einvAuth(false));
      dispatch(einvPreview({ preview: false, id: 0 }));
      dispatch(einvId(false));
    }
  };
  const handleSelectAllClick = (event) => {
    const isChecked = event.target.checked;
    if (isChecked && invoiceRows.length) {
      const newSelected = invoiceRows.map((n) => ({
        Email: n?.partyemail,
        partyaccountid: n?.partyaccountid,
        PartyDisplayName: n?.partyname,
        PartyID: n?.partyid,
        partytypecd: n?.partytypecd,
        invoiceid: n?.invoiceid,
        invoicenumber: n?.invoicenumber,
      }));
      setSelected(newSelected);
      setEmailSendingSelection(newSelected);
      return;
    }
    setSelected([]);
    setEmailSendingSelection([]);
  };

  const handleClick = (event, row) => {
    const selectedIndex = selected.findIndex((item) => item.invoiceid === row.invoiceid);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, {
        Email: row?.partyemail,
        partyaccountid: row?.partyaccountid,
        PartyDisplayName: row?.partyname,
        PartyID: row?.partyid,
        partytypecd: row?.partytypecd,
        invoiceid: row?.invoiceid,
        invoicenumber: row?.invoicenumber,
      });
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
    setEmailSendingSelection(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    if (circularOpen) return;
    if (newPage > page) {
      if (invoiceRows.length !== dataCount)
        if (invoiceRows.length <= rowsPerPageRef.current * newPage) listInvoices(false, invoiceRows.length, rowsPerPageRef.current);
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    if (circularOpen) return;
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (invoiceId) => selected.some((item) => item.invoiceid === invoiceId);

  // Store latest values in refs to avoid stale closures
  const rowsPerPageRef = useRef(rowsPerPage);
  rowsPerPageRef.current = rowsPerPage;

  const filterColumnsRef = useRef(filterColumns);
  filterColumnsRef.current = filterColumns;

  if (!debouncedSearchRef.current) {
    debouncedSearchRef.current = createDebouncedCallback(
      (obj) => {
        // Always use current values from refs
        const currentFilterColumns = filterColumnsRef.current;
        const currentRowsPerPage = rowsPerPageRef.current;

        // Check if there are any non-empty filter values
        const hasFilters = Object.values(currentFilterColumns).some((value) => value && value.toString().trim().length > 0);

        if (hasFilters) {
          listInvoices(true, 0, currentRowsPerPage, currentFilterColumns);
        } else {
          listInvoices(true, 0, currentRowsPerPage);
        }
      },
      500,
      false
    );
  }

  const filterSearch = useCallback((obj) => {
    debouncedSearchRef.current(obj);
  }, []);

  useEffect(() => {
    if (firstMount.current === false) {
      // Use the debounced search which will check current filterColumns
      filterSearch();
    }
    return () => {};
  }, [filterColumns, filterSearch]);

  useEffect(() => {
    const controlAndS = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 's') {
        e.preventDefault();
        // showErrorSnackbar("Nothing to save");
      }
    };

    window.addEventListener('keydown', controlAndS);

    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, []);

  const handleFilterBySearch = (event, category, value) => {
    setPage(0);
    let query = value ? value : event.target?.value;
    let name = category;
    const obj = { ...filterColumnsRef.current };
    if (name == 'GrandTotalAmount') {
      obj['AmountFrom'] = query[0];
      obj['AmountTo'] = query[1];
    } else if (name === 'BalanceDueAmount') {
      obj['balancedueamountfrom'] = query[0];
      obj['balancedueamountto'] = query[1];
    } else {
      for (const key in obj) {
        if (key == name) {
          obj[key] = query;
        } else {
          // obj[key] = "";
        }
      }
    }
    setFilterColumns(obj);
  };
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPageRef.current - invoiceRows.length) : 0;

  useEffect(() => {
    if (firstMount.current === false) {
      if (rowsPerPageRef.current > invoiceRows.length) {
        listInvoices(true, 0, rowsPerPageRef.current);
      } else {
      }
    }
    return () => {};
  }, [rowsPerPage]);

  useEffect(() => {
    if (firstMount.current === false) {
      // setFilteredList([]);
      setInvoiceROws([]);
      setPage(0);
      clearEmailSelection();
      setSelected([]);
      listInvoices(true, 0, rowsPerPageRef.current);
    }
    return () => {};
  }, [order, orderBy]);
  const [limit, setlimit] = useState(rowsPerPage);

  const [dataLoader, setDataLoader] = useState(true);
  async function listInvoices(reset, from, to, filterColumn) {
    return new Promise(async (resolve, reject) => {
      try {
        setDataLoader(true);
        if (invoiceRows?.length / rowsPerPageRef.current == page + 1) {
          setlimit(to);
        } else if (invoiceRows?.length / rowsPerPageRef.current < 1) {
          setlimit(rowsPerPageRef.current - invoiceRows?.length);
        }
        setCircularOpen(true);
        if (reset) {
          setInvoiceROws([]);
          setPage(0);
        }
        let searchMode = 1;
        let SearchArray = [{ invoicetypecd: 'SalesInvoice' }];
        filterColumn = filterColumn ? filterColumn : filterColumnsRef.current;
        // Handle AmountFrom and AmountTo together to avoid duplicates
        const amountFrom = filterColumn.AmountFrom || '';
        const amountTo = filterColumn.AmountTo || '';

        if (amountFrom || amountTo) {
          searchMode = 1;
          // Ensure From < To before adding to SearchArray
          const lowerAmount = Number(amountFrom < amountTo ? amountFrom : amountTo);
          const higherAmount = Number(amountFrom < amountTo ? amountTo : amountFrom);

          // Add both values with correct order
          SearchArray = [...SearchArray, { amountfrom: lowerAmount }, { amountto: higherAmount }];
        } else if (amountFrom) {
          searchMode = 1;
          SearchArray = [...SearchArray, { amountfrom: amountFrom }];
        } else if (amountTo) {
          searchMode = 1;
          SearchArray = [...SearchArray, { amountto: amountTo }];
        }

        // Handle BalanceDueAmountFrom and BalanceDueAmountTo together to avoid duplicates
        const balanceDueAmountFrom = filterColumn.balancedueamountfrom || '';
        const balanceDueAmountTo = filterColumn.balancedueamountto || '';

        if (balanceDueAmountFrom || balanceDueAmountTo) {
          searchMode = 1;
          // Ensure From < To before adding to SearchArray
          const lowerBalanceDueAmount = Number(balanceDueAmountFrom < balanceDueAmountTo ? balanceDueAmountFrom : balanceDueAmountTo);
          const higherBalanceDueAmount = Number(balanceDueAmountFrom < balanceDueAmountTo ? balanceDueAmountTo : balanceDueAmountFrom);

          // Add both values with correct order
          SearchArray = [...SearchArray, { balancedueamountfrom: lowerBalanceDueAmount }, { balancedueamountto: higherBalanceDueAmount }];
        } else if (balanceDueAmountFrom) {
          searchMode = 1;
          SearchArray = [...SearchArray, { balancedueamountfrom: balanceDueAmountFrom }];
        } else if (balanceDueAmountTo) {
          searchMode = 1;
          SearchArray = [...SearchArray, { balancedueamountto: balanceDueAmountTo }];
        }

        Object.keys(filterColumn).map((key) => {
          if (filterColumn[key]?.toString()?.length > 0) {
            // Skip AmountFrom, AmountTo, balancedueamountfrom, and balancedueamountto as they are handled above
            if (key !== 'AmountFrom' && key !== 'AmountTo' && key !== 'balancedueamountfrom' && key !== 'balancedueamountto') {
              searchMode = 1;
              SearchArray = [...SearchArray, { [key?.toLowerCase()]: filterColumn[key] }];
            }
          }
        });
        const resActive = API.graphql(
          graphqlOperation(listInvoiceMasterv2Custom, {
            rowfrom: from,
            limitno: to,
            columnname: orderBy,
            ordertype: order,
            searchmode: searchMode,
            searcharray: JSON.stringify(SearchArray),
          })
        );
        const resCount = API.graphql(
          graphqlOperation(listInvoiceMasterCount, {
            columnname: orderBy,
            ordertype: order,
            searchmode: searchMode,
            searcharray: JSON.stringify(SearchArray),
          })
        );
        Promise.all([resActive])
          .then((response) => {
            let res = response[0];

            let arr = [];
            let arrD = [];
            if (res.data?.listInvoiceMasterv2 != null) {
              let Id = '';
              let type = '';
              arr = res.data?.listInvoiceMasterv2.filter((ele) => {
                ele.partyname = ele.partydisplayname;
                partyDetails.map((item) => {
                  if (item.partylegalname == ele.partyname) {
                    type = item.partytypecd;
                    Id = item.partyid;
                  }
                });
                ele.customerorsupplierid = ele.partyid;
                ele.customerorsuppliertype = type;
                // Calculate due date using utility function
                ele.duedate = addDaysToDate(ele.invoicedate, ele.creditduration);

                // Format invoice date using utility function
                ele.InvoiceDate = formatUnixTimestamp(ele.invoicedate);
                ele.statuscd = ele.receivedamount >= ele.invoiceamount ? 'Paid' : ele.receivedamount === 0 ? 'Unpaid' : 'Partial';
                ele.balancedue =
                  Number(ele.invoiceamount) - Number(ele.receivedamount) > 0 ? Number(ele.invoiceamount) - Number(ele.receivedamount) : 0;
                ele.duedatetimestamp = new Date(ele.duedate).getTime();
                ele.invoicedatetimestamp = new Date(ele.invoicedate).getTime();
                // Get the Unix timestamp in milliseconds
                return ele;
              });
              // setInvoiceROws(arr)
              // setFilteredList(arr)
            } else {
            }

            let cArr = [...arr, ...arrD];
            if (reset) {
              setInvoiceROws((prev) => [...cArr]);
              setDataLoader(false);
              // setFilteredList((prev) => [...cArr]);
            } else {
              setInvoiceROws((prev) => [...prev, ...cArr]);
              setDataLoader(false);
              // setFilteredList((prev) => [...prev, ...cArr]);
            }
          })
          .finally(() => {
            setlimit(0);
            setCircularOpen(false);
            resolve();
          });
        Promise.all([resCount]).then((response) => {
          let dres = response[0];
          setdataCount(parseInt(dres.data?.listInvoiceMasterCount?.[0]?.invoicemasterlistcount || 0));
        });
      } catch (error) {
        setlimit(0);
        resolve();
        console.log(error);
      }
    });
  }

  useEffect(() => {
    setCircularOpen(true);
  }, []);

  useEffect(() => {
    setListSelection('All');
    setInvoiceROws([]);
    // setFilteredList([]);
    setCircularOpen(true);
    listInvoices(true, 0, rowsPerPageRef.current);
    setSelected([]);
    clearEmailSelection();
    if (firstMount.current) {
      firstMount.current = false;
    }
  }, [salesTableState]);

  //New Changes
  // useEffect(() => {
  //   setFilteredList(invoiceRows);
  // }, [invoiceRows]);
  //New Changes

  function invoiceFilterSearch(event, category) {
    setPage(0);
    const query = event.target.value;
    const name = category;
    const obj = { ...filterColumnsRef.current };
    for (const key in obj) {
      if (key == name) {
        obj[key] = query;
      } else {
        // obj[key] = "";
      }
    }
    setFilterColumns(obj);
  }

  async function getCompanyDetails() {
    try {
      setGstStatus(getCompany?.relatedcompanydetailsnew[0].registrationtype);
      setCOmpanyDetails(companyDetails?.data);
    } catch (error) {
      console.log('error', error);
    }
  }
  useEffect(() => {
    if (getCompany) getCompanyDetails();
  }, [getCompany]);
  //New Changes

  const [ledgerModalStartDate, setLedgerModalStartDate] = useState(0);
  const [ledgerModalEndDate, setLedgerModalEndDate] = useState(0);

  const [accountID, setAccountID] = useState('');

  const userPrefrenceandReducer = useSelector((state) => state.userPrefrenceandReducer);
  useEffect(() => {
    if (userPrefrenceandReducer?.financialYear) {
      setLedgerModalStartDate(userPrefrenceandReducer?.financialYear?.startdate);
      setLedgerModalEndDate(userPrefrenceandReducer?.financialYear?.enddate);
    }
  }, [userPrefrenceandReducer]);
  //New Changes

  const handleRowClick = (row) => {
    // dispatch(updateTitle(row.CancelFlag == 1 ? JSON.stringify({ type: "Cancelled", name: row.InvoiceNumber }) :
    //   JSON.stringify({ type: "", name: row.InvoiceNumber })));
    // dispatch(updateViewTitle(row.cancelflag == 1 ? { type: 'Cancelled', name: row.invoicenumber } : { type: '', name: row.invoicenumber }));
    dispatch(updateTitle(row.invoicenumber));
    if (row.invoicetypecd == 'SalesInvoice') {
      navigate('/viewnewinvoicetax', {
        state: { id: row.invoiceid, view: true, irn: row?.irn },
      });
    } else if (row.invoicetypecd == 'NON-TAXABLE') {
      navigate('/viewinvoiceNonTaxable', {
        state: { id: row.invoiceid, view: true },
      });
    } else if (row.invoicetypecd == 'PosInvoice') {
      navigate('/viewpos', {
        state: { id: row.invoiceid, view: true },
      });
    }
  };

  const [ListSelection, setListSelection] = useState('All');
  const [emailSendingSelection, setEmailSendingSelection] = useState([]);
  const [individualEmailSelection, setIndividualEmailSelection] = useState([]);
  const [EnableSearch, setEnableSearch] = useState(false);
  const DateRangeRef = useRef(null);
  const openDateRange = () => {
    setEnableSearch(true);
    DateRangeRef?.current?.openDatePicker();
  };
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);

  const tableRef = useRef(null);
  const [shadow, setShadow] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (tableRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = tableRef.current;
        // Check if the table is scrolled to the very right
        if (scrollLeft + clientWidth >= scrollWidth) {
          setShadow(false);
        } else {
          setShadow(true);
        }
      }
    };

    const tableElement = tableRef.current;
    if (tableElement) {
      tableElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (tableElement) {
        tableElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    if (invoiceRows.length > 0 && !circularOpen) {
      const width = slaeInvoiceTaableRef.current?.offsetWidth;
      const screenWidth = window.innerWidth;
      if (width < screenWidth) {
        setScroll(false);
      } else {
        setScroll(true);
      }
    }
  }, [invoiceRows, circularOpen]);

  const device = useMediaQuery(theme.breakpoints.down('sm'));

  const [createPdf, create, progress] = useCreatePdfMutation();
  const generatePDF = async (invoicenumber, invoiceid) => {
    const response = await create({
      path: 'test20.pdf',
      invoiceids: invoiceid,
      type: 'purchaseInvoice',
    });
  };
  const isLocal = IS_LOCAL == 'true';
  const [rolling, setRolling] = useState(false);

  return (
    <Box className="noTableCellBorder">
      {/* <ConfirmDeleteModal open={deleteModalStatus} setOpen={setDeleteModalStatus} /> */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTopRightRadius: '12px',
          borderTopLeftRadius: '12px',
          padding: '8px 10px',
          backgroundColor: 'primary.main',
          // marginBottom:'20px'
        }}
      >
        <Box sx={{ display: 'flex', flex: { xs: 1, sm: 0 } }}>
          <Link
            onClick={(e) => {
              e.stopPropagation();
              if (Freeze == 1) {
                e.preventDefault();
                return handleFreeze();
              }
              localStorage.removeItem('SalesIDTaxable');
              localStorage.removeItem('SalesTaxViewMode');
              localStorage.removeItem('SalesIDNonTaxable');
              localStorage.removeItem('SalesNonTaxViewMode');
              localStorage.removeItem('PosID');
              localStorage.removeItem('PosViewMode');
              dispatch(einvAuth(false));
            }}
            to={
              // gstStatus == 1
              //   ? "/addinvoiceNonTaxable"
              //   : salesTableState === "pos"
              //     ? "/addpos"
              //     : "/addinvoiceTaxable"
              salesTableState === 'pos' ? '/newpos' : '/addnewinvoicetax'
            }
            // target="_blank"
          >
            <Button
              sx={{
                whiteSpace: 'nowrap',
                border: '1px solid white',
                boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
                m: '0 10px',
                fontWeight: 'bold',
                backgroundColor: 'white',
                '&:hover': {
                  backgroundColor: 'white', // Override hover background color
                },
              }}
              variant="outlined"
              startIcon={<Add />}
            >
              Add Invoice
            </Button>
          </Link>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <TableSearchButton
            setEnableSearch={setEnableSearch}
            EnableSearch={EnableSearch}
            id={'salesInvoiceSearch'}
            onClick={handleResetFilterColumns}
          />
          <Box
            sx={{
              display: {
                xs: 'none',
                sm: 'flex',
                md: 'flex',
                lg: 'flex',
                xl: 'flex',
                gap: '10px',
              },
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                whiteSpace: 'nowrap',
                fontSize: { md: '13px', sm: '12px' },
                color: 'white',
              }}
            >
              Total : {dataCount} Item{dataCount !== 1 && 's'} {selected.length !== 0 ? `(Selected: ${selected.length}/${dataCount})` : ''}
            </Typography>
            <DropDownForListing
              name={'ser'}
              value={ListSelection}
              sx={{ color: 'white' }}
              onChange={(e) => {
                let value = e.target.value;
                setListSelection(e.target.value);
                setFilterColumns((prev) => ({
                  ...prev,
                  CancelFlag: value != 'All' ? (value == 'Active' ? 0 : 1) : '',
                }));
                setPage(0);
              }}
            />
            <PeriodDropDown
              custom={openDateRange}
              onChange={(start, end) => {
                setFilterColumns((prev) => ({
                  ...prev,
                  InvoiceDateFrom: start,
                  InvoiceDateTo: end,
                }));
              }}
            />
            {/* <IconButton aria-label="filter">
                  <FilterAlt sx={{color:'#fff'}} />
                </IconButton>
                <IconButton aria-label="more">
                    <MoreVert sx={{color:'#fff'}} />
                </IconButton> */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                borderRadius: '5px',
                p: 1,
                cursor: 'pointer',
                '&:hover': {
                  borderColor: '#ccc',
                  backgroundColor: theme.palette.input.border,
                },
              }}
              onClick={handleClickBox} // Toggle the popover on box click
            >
              <MoreVert sx={{ fontSize: '20px', color: '#fff' }} />

              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <Box sx={{ p: 1 }}>
                  {options.map((option, index) =>
                    option.rollingOutSoon ? (
                      <Typography
                        key={index}
                        onClick={() => {
                          handleClose();
                        }}
                        sx={{
                          padding: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          // '&:hover': {
                          //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                          // },
                        }}
                      >
                        <Tooltip
                          title={<RollingSoon />}
                          placement="right"
                          PopperProps={{
                            sx: {
                              '& .MuiTooltip-tooltip': {
                                backgroundColor: 'transparent',
                                boxShadow: 'none',
                                padding: 0,
                              },
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {option.icon}
                            <span style={{ marginLeft: '8px', opacity: 0.5 }}>{option.label}</span>
                          </Box>
                        </Tooltip>
                      </Typography>
                    ) : (
                      <Link style={{ textDecoration: 'none', color: 'inherit' }} to={option.link} state={{ fromLink: '/customerList' }}>
                        <Typography
                          key={index}
                          onClick={() => {
                            handleClose();
                            option.onClick();
                          }}
                          sx={{
                            cursor: 'pointer',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            // '&:hover': {
                            //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                            // },
                          }}
                        >
                          {option.icon}
                          <span style={{ marginLeft: '8px' }}>{option.label}</span>
                        </Typography>
                      </Link>
                    )
                  )}
                </Box>
              </Popover>
            </Box>
          </Box>
        </Box>
      </Box>
      <>
        <Box
          sx={{
            // boxShadow: "inset 0 0 8px #d7d7d73b",
            boxShadow: 'rgb(33 35 38 / 10%) 0px 10px 10px -10px',
            borderBottomRightRadius: '12px',
            borderBottomLeftRadius: '12px',
            // backgroundColor: theme.palette.bodyGray.secondary,
            // borderRadius:'12px',
            padding: {
              // xs: "8px 12px",
            },
            '.css-1mxz8qt-MuiPaper-root': {
              boxShadow: 'none',
            },
            '.MuiTableCell-root': {
              padding: '1px 10px',
              fontSize: '13px',
            },
            '.MuiTableCell-head': {
              // backgroundColor: "background.tablebg",
              padding: '5px 10px',
              borderBottom: '0px',
            },
          }}
        >
          {invoiceRows.length <= 0 && device ? (
            <Typography
              sx={{
                height: '70vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              No data found
            </Typography>
          ) : (
            <>
              {salesTableState === 'invoice' && (
                <Box
                  sx={{
                    width: '100%',
                    overflow: 'hidden',
                    boxShadow: 'none',
                  }}
                >
                  <TableContainer
                    ref={tableRef}
                    className="custom-scrollbar"
                    sx={{
                      height: {
                        sm: 'calc( 100vh - 230px )',
                        xs: 'calc( 100vh - 180px )',
                      },
                    }}
                  >
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      // sx={{ minWidth: 750 }}
                      aria-labelledby="tableTitle"
                      size={dense ? 'small' : 'medium'}
                    >
                      <EnhancedTableHead
                        EnableSearch={EnableSearch}
                        setEnableSearch={setEnableSearch}
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={handleRequestSort}
                        rowCount={dataCount || 0}
                        headCell={invoiceHeadCells}
                        onDelete={() => setDeleteSelectedModal(true)}
                        getCompany={getCompany}
                        rowList={invoiceRows}
                        visiblerowlength={invoiceRows.length}
                        setShowActions={setShowActions}
                        showActions={showActions}
                        scroll={scroll}
                      />
                      <TableBody ref={slaeInvoiceTaableRef}>
                        <TableRow
                          sx={{
                            '.MuiTableCell-root': {
                              backgroundColor: 'transparent ',
                              padding: '8px 15px',
                            },
                            '.css-wrnu0i-MuiInputBase-root': {
                              fontSize: '13px',
                            },
                            '.css-xk0adg-MuiButtonBase-root-MuiIconButton-root': {
                              padding: '2px 4px',
                            },
                            '.css-1gqfvv-MuiPaper-root': {
                              boxShadow: 'none',
                              borderBottom: 'solid 1px rgba(0,0,0,0.24)',
                              borderRadius: '0px',
                            },
                            // visibility: !EnableSearch ? "collapse" : "visible",
                            display: !EnableSearch ? 'none' : 'content',
                          }}
                          className="noTableCellBorder"
                        >
                          <TableCell></TableCell>
                          <TableCell>
                            <Paper
                              id="salesInvoiceSearch"
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <DateRangeRsuite
                                ref={DateRangeRef}
                                containerRef={tableRef}
                                className="hide-input-outline hide-input-border"
                                value={[
                                  filterColumns.InvoiceDateFrom ? filterColumns.InvoiceDateFrom : null,
                                  filterColumns.InvoiceDateTo ? filterColumns.InvoiceDateTo : null,
                                ]}
                                onChange={(e) => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    InvoiceDateFrom: e.from ? e.from : '',
                                    InvoiceDateTo: e.to ? e.to : '',
                                  }));
                                }}
                                shouldDisableDate={(date) => {
                                  const startDate = userPreferece?.financialYear?.startdate;
                                  const endDate = userPreferece?.financialYear?.enddate;
                                  if (!startDate || !endDate) return false;
                                  const dateTime = date.getTime() / 1000;
                                  return dateTime < startDate || dateTime > endDate;
                                }}
                              />
                              {/* <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.InvoiceDateFrom !== '' || filterColumns.InvoiceDateTo != '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        InvoiceDateFrom: '',
                                        InvoiceDateTo: '',
                                      }));
                                      // setFilteredList(rows);
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton> */}
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <InputBase
                                name="InvoiceNumber"
                                value={filterColumns.InvoiceNumber}
                                onChange={(e) => invoiceFilterSearch(e, 'InvoiceNumber')}
                                sx={{ flex: 1 }}
                                placeholder="Search"
                                autoComplete="off"
                              />
                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.InvoiceNumber !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        InvoiceNumber: '',
                                      }));
                                      // setFilteredList(invoiceRows);
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <InputBase
                                name="CustomerName"
                                value={filterColumns.CustomerName}
                                onChange={(e) => invoiceFilterSearch(e, 'CustomerName')}
                                sx={{ flex: 1 }}
                                placeholder="Search"
                                autoComplete="off"
                              />
                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.CustomerName !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        CustomerName: '',
                                      }));
                                      // setFilteredList(invoiceRows);
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',

                                width: '100%',
                              }}
                            >
                              <Stack direction={'row'} height={'32px'} gap="5px">
                                <MoneyTextFieldRange
                                  value={[filterColumns.AmountFrom, filterColumns.AmountTo]}
                                  onChange={(e) => {
                                    handleFilterBySearch(e, 'GrandTotalAmount', e);
                                  }}
                                />

                                <IconButton type="button" sx={{ p: '0px' }}>
                                  {filterColumns.AmountFrom !== '' || filterColumns.AmountTo !== '' ? (
                                    <Clear
                                      fontSize="small"
                                      onClick={() => {
                                        setFilterColumns((prev) => ({
                                          ...prev,
                                          AmountFrom: '',
                                          AmountTo: '',
                                        }));
                                      }}
                                    />
                                  ) : (
                                    <SearchIcon fontSize="small" />
                                  )}
                                </IconButton>
                              </Stack>
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',

                                width: '100%',
                              }}
                            >
                              <Stack direction={'row'} height={'32px'} gap="5px">
                                <MoneyTextFieldRange
                                  value={[filterColumns.balancedueamountfrom, filterColumns.balancedueamountto]}
                                  onChange={(e) => {
                                    handleFilterBySearch(e, 'BalanceDueAmount', e);
                                  }}
                                />

                                <IconButton type="button" sx={{ p: '0px' }}>
                                  {filterColumns.balancedueamountfrom !== '' || filterColumns.balancedueamountto !== '' ? (
                                    <Clear
                                      fontSize="small"
                                      onClick={() => {
                                        setFilterColumns((prev) => ({
                                          ...prev,
                                          balancedueamountfrom: '',
                                          balancedueamountto: '',
                                        }));
                                      }}
                                    />
                                  ) : (
                                    <SearchIcon fontSize="small" />
                                  )}
                                </IconButton>
                              </Stack>
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              {/* <InputBase
                        name="supplierInvoiceDate"
                        value={filterColumns.supplierInvoiceDate}
                        onChange={(e) =>
                          handleFilterBySearch(e, "SupplierInvoiceDate")
                        }
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      /> */}
                              <DateRangeRsuite
                                containerRef={tableRef}
                                className="hide-input-outline hide-input-border"
                                value={[
                                  filterColumns.DueDateFrom ? filterColumns.DueDateFrom : null,
                                  filterColumns.DueDateTo ? filterColumns.DueDateTo : null,
                                ]}
                                onChange={(e) => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    DueDateFrom: e.from ? e.from : '',
                                    DueDateTo: e.to ? e.to : '',
                                  }));
                                }}
                                shouldDisableDate={(date) => {
                                  const startDate = userPreferece?.financialYear?.startdate;
                                  const endDate = userPreferece?.financialYear?.enddate;
                                  if (!startDate || !endDate) return false;
                                  const dateTime = date.getTime() / 1000;
                                  return dateTime < startDate || dateTime > endDate;
                                }}
                              />
                              {/* <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.DueDateFrom !== '' || filterColumns.DueDateTo != '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        DueDateFrom: '',
                                        DueDateTo: '',
                                      }));
                                      // setFilteredList(rows);
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton> */}
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <InputBase
                                name="OverDueDays"
                                type="number"
                                value={filterColumns.OverDueDays}
                                onChange={(e) => invoiceFilterSearch(e, 'OverDueDays')}
                                sx={{ flex: 1 }}
                                placeholder="Search"
                                autoComplete="off"
                              />
                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.OverDueDays !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        OverDueDays: '',
                                      }));
                                      // setFilteredList(invoiceRows);
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                border: 'none',
                              }}
                            >
                              <Autocomplete
                                id={''}
                                disableClearable
                                options={['UNPAID', 'PAID', 'PARTIAL']}
                                isOptionEqualToValue={(option, value) => option == value}
                                clearIcon={filterColumns.Status !== '' ? <ClearIcon style={{ fontSize: '20px' }} /> : null}
                                value={filterColumns.Status}
                                // onChange={onChange}
                                onChange={(e, value) => handleFilterBySearch(e, 'Status', value)}
                                size="small"
                                sx={{ height: '32px' }}
                                renderOption={(props, option) => (
                                  <>
                                    <MenuItem {...props} key={option} value={option}>
                                      <ListItemText primary={option} />
                                    </MenuItem>
                                  </>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    sx={{
                                      // mt: filterColumns.Status ? "10px" : "-14px",
                                      // ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                      // {
                                      //   padding: "8.5px 7px",
                                      // },
                                      // ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                      // {
                                      //   fontSize: "14px",
                                      // },
                                      // label: {
                                      //   fontSize: "14px",
                                      // },
                                      // ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                      // {
                                      //   fontSize: "14px",
                                      // },
                                      // ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                      // {
                                      //   color: "input.font",
                                      // },
                                      // ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                      // {
                                      //   border: "none", // Ensure border is removed
                                      // },
                                      // ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                      // {
                                      //   color: "input.font",
                                      // },
                                      // ".css-14qz1ij-MuiListItemText-root": {
                                      //   margin: "0px",
                                      // },
                                      // ".css-wgai2y-MuiFormLabel-asterisk": {
                                      //   color: "danger.main",
                                      // },
                                      minWidth: '100px',
                                      border: 'none', // Ensure border is removed
                                      '& .MuiInput-underline:before': {
                                        borderBottom: 'none', // Remove underline in standard variant
                                      },
                                      '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                                        borderBottom: 'none', // Remove hover effect
                                      },
                                      '& .MuiInput-underline:after': {
                                        borderBottom: 'none', // Remove underline for focused state
                                      },
                                      '& fieldset': { border: 'none' },
                                    }}
                                    placeholder={'Search'}
                                    variant="standard"
                                    InputLabelProps={{
                                      shrink: true,
                                      style: { color: 'black' },
                                    }}
                                    // onFocus={(e) => {
                                    //   // When the input is focused, change the label to empty
                                    //   e.target.placeholder = ""; // Remove placeholder text on focus if needed
                                    // }}
                                    // onBlur={(e) => {
                                    //   // When the input loses focus, revert changes if necessary
                                    //   e.target.placeholder = filterColumns.Status
                                    //     ? ""
                                    //     : "Search"; // Revert placeholder text on blur if needed
                                    // }}
                                    {...params}
                                  />
                                )}
                              />
                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.Status !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        Status: '',
                                      }));
                                      // setFilteredList(invoiceRows);
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Paper>
                          </TableCell>
                          {/* <TableCell>
                      <Paper
                        sx={{
                          p: "2px 4px",
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <InputBase
                          name="BalanceDue"
                          value={filterColumns.BalanceDue}
                          onChange={(e) => invoiceFilterSearch(e, "BalanceDue")}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ p: "0px" }}>
                          {filterColumns.BalanceDue !== "" ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  BalanceDue: "",
                                }));
                                setFilteredList(invoiceRows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell> */}

                          <TableCell
                            sx={{
                              // backgroundColor: theme.palette.bodyGray.secondary,
                              position: 'sticky',
                              right: 0,
                              backgroundColor: 'transparent !important',
                            }}
                            className="actionBackGround"
                          >
                            {' '}
                            {/* <InputBase /> */}
                          </TableCell>
                          <TableCell sx={{ backgroundColor: 'transparent !important' }}> {/* <InputBase /> */}</TableCell>
                        </TableRow>
                        {invoiceRows?.length > 0 ? (
                          invoiceRows
                            .slice(page * rowsPerPageRef.current, page * rowsPerPageRef.current + rowsPerPageRef.current)
                            .map((row, index) => {
                              const isItemSelected = isSelected(row.invoiceid);
                              const labelId = `enhanced-table-checkbox-${index}`;

                              let status = row.statuscd;
                              switch (row.statuscd) {
                                case 'Paid':
                                  status = (
                                    <Typography
                                      sx={{
                                        color: row.cancelflag === 1 ? '#cccccc' : '#009933',
                                        fontSize: '13px',
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <CheckCircleIcon
                                        sx={{
                                          fontSize: '15px',
                                          marginRight: '5px',
                                        }}
                                      />{' '}
                                      {row.statuscd}
                                    </Typography>
                                  );
                                  break;
                                case 'Unpaid':
                                  status = (
                                    <Typography
                                      sx={{
                                        color: row.cancelflag === 1 ? '#cccccc' : '#eb4141',
                                        fontSize: '13px',
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <ErrorIcon
                                        sx={{
                                          fontSize: '15px',
                                          marginRight: '5px',
                                        }}
                                      />{' '}
                                      {row.statuscd}
                                    </Typography>
                                  );
                                  break;
                                case 'Partial':
                                  status = (
                                    <Typography
                                      sx={{
                                        color: row.cancelflag === 1 ? '#cccccc' : '#6096d9',
                                        fontSize: '13px',
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <RunningWithErrorsIcon
                                        sx={{
                                          fontSize: '15px',
                                          marginRight: '5px',
                                        }}
                                      />{' '}
                                      {row.statuscd}
                                    </Typography>
                                  );
                                  break;

                                default:
                                  break;
                              }
                              let currencySymbol = '₹'; // billingCurrencyOptions.find(
                              //   (elem) => row.CurrencyCode == elem.value
                              // )?.sign;
                              const dat = new Date(row?.einvoiceenteredtimestamp * 1000);
                              const ewayDat = new Date(row?.ewaybillenteredtimestamp * 1000);
                              const dayjsDat = dayjs(dat);
                              const dayjsEwayDat = dayjs(ewayDat);
                              const currentDate = dayjs(); // This keeps the time part as well!

                              // Calculate the difference in hours
                              const diff = currentDate.diff(dayjsDat, 'hour', true).toFixed(2);

                              const diffEway = currentDate.diff(dayjsEwayDat, 'hour', true);
                              console.log(row, 'hhhhhhhhhhhh');
                              console.log(diff - 24, 'diff');
                              return (
                                <TableRow
                                  className={row.cancelflag === 1 ? 'rowInactiveMuted' : ''}
                                  hover
                                  // onClick={(event) => handleClick(event, row.date)}
                                  role="checkbox"
                                  aria-checked={isItemSelected}
                                  tabIndex={-1}
                                  key={index}
                                  selected={isItemSelected}
                                  onClick={() => handleRowClick(row)}
                                  style={{ cursor: 'pointer' }}
                                  sx={{
                                    '.MuiTableCell-root': {
                                      backgroundColor: 'transparent ',
                                      borderBottom: 'none',
                                    },
                                  }}
                                >
                                  <TableCell
                                    title={row.cancelflag === 1 ? 'Cancelled' : ''}
                                    // padding="checkbox"
                                    sx={{
                                      '.css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root': {
                                        padding: '5px',
                                      },
                                      padding: '0px',
                                      '& .MuiCheckbox-root': {
                                        padding: '4px',
                                      },
                                    }}
                                  >
                                    <Checkbox
                                      onClick={(event) => {
                                        event.stopPropagation();
                                      }}
                                      onChange={(event) => {
                                        event.stopPropagation();
                                        handleClick(event, row);
                                      }}
                                      color="primary"
                                      checked={isItemSelected}
                                      inputProps={{
                                        'aria-labelledby': labelId,
                                      }}
                                      size="small"
                                    />
                                  </TableCell>
                                  <TableCell
                                    title={row.cancelflag === 1 ? 'Cancelled' : ''}
                                    // component="th"
                                    id={labelId}
                                    scope="row"
                                    sx={{ whiteSpace: 'nowrap' }}
                                    // padding="none"
                                  >
                                    {row.InvoiceDate}
                                  </TableCell>
                                  {/* <TableCell
                                    align="left"
                                    title={
                                      row.cancelflag === 1 ? "Cancelled" : ""
                                    }
                                  >
                                    <MUILink
                                      // underline="hover"
                                      sx={{ cursor: "pointer",fontSize:"13px" }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        dispatch(
                                          updateViewTitle(
                                            row.cancelflag == 1
                                              ? {
                                                  type: "Cancelled",
                                                  name: row.invoicenumber,
                                                }
                                              : {
                                                  type: "",
                                                  name: row.invoicenumber,
                                                }
                                          )
                                        );
                                        // if (row.TAXABLE == "TAXABLE") {
                                        navigate(
                                          // "/viewinvoiceTaxable",
                                          "/viewnewinvoicetax",
                                          {
                                            state: {
                                              id: row.invoiceid,
                                              view: true,
                                            },
                                          }
                                        );
                                        // } else if (
                                        //   row.InvoiceTaxableTypeCD == "NON-TAXABLE"
                                        // ) {
                                        //   navigate("/viewnewinvoicetax", {
                                        //     state: {
                                        //       id: row.InvoiceID,
                                        //       view: true,
                                        //     },
                                        //   });
                                        // }
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontSize: "13px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {" "}
                                        <Typography>
                                          {" "}
                                          {row.invoicenumber}{" "}
                                        </Typography>
                                      </Typography>
                                    </MUILink>
                                  </TableCell> */}
                                  <TableCell align="left" title={row.cancelflag === 1 ? 'Cancelled' : ''}>
                                    <a
                                      className="myLink"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                      href={`/viewnewinvoicetax/${row.invoicenumber}?transaction=${row.invoiceid}`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {row.invoicenumber}
                                    </a>
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    onClick={(e) => {
                                      dispatch(updateTitle(row.partydisplayname));
                                    }}
                                    title={row.cancelflag === 1 ? 'Cancelled' : ''}
                                    sx={{
                                      maxWidth: '100px',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    <Tooltip title={row?.partyname} placement="right">
                                      <span
                                        style={{
                                          display: 'block',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                        }}
                                      >
                                        {' '}
                                        <a
                                          className="myLink"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            dispatch(updateTitle(row.partydisplayname));
                                          }}
                                          href={`/viewcustomer?id=${row.customerorsupplierid}&view=true&title=${row.partydisplayname}`}
                                          target="_blank"
                                        >
                                          {row?.partyname}
                                        </a>
                                      </span>
                                    </Tooltip>
                                    {/* </Link> */}
                                  </TableCell>

                                  <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} align="right">
                                    <a
                                      underline="hover"
                                      style={{
                                        color: theme.palette.text.Link,
                                        cursor: 'pointer',
                                      }}
                                      href={`/LedgerTransactions/${row?.partyaccountid}`}
                                      onClick={(e) => {
                                        dispatch(updateTitle(row.invoicenumber));
                                        e.stopPropagation();
                                        e.preventDefault();
                                        if (row?.partyaccountid !== '') {
                                          // setBackdropOpen(true);
                                          // setAccountName(row?.PartyDisplayName);
                                          setAccountID(row?.partyaccountid);
                                          // getModalData(row?.PartyAccountID);
                                        }
                                      }}
                                    >
                                      {currencySymbol} {MoneyFormatv3(row.invoiceamount, 'en-IN')}
                                    </a>
                                  </TableCell>

                                  <TableCell sx={{ whiteSpace: 'nowrap' }} title={row.cancelflag === 1 ? 'Cancelled' : ''} align="right">
                                    {/* <a
                                    underline="hover"
                                    style={{
                                      color: theme.palette.text.Link,
                                      cursor: 'pointer',
                                    }}
                                    href={`/LedgerTransactions/${row?.partyaccountid}`}
                                    onClick={(e) => {
                                      dispatch(updateTitle(row.invoicenumber));
                                      e.stopPropagation();
                                      e.preventDefault();
                                      if (row?.partyaccountid !== '') {
                                        // setBackdropOpen(true);
                                        // setAccountName(row?.PartyDisplayName);
                                        setAccountID(row?.partyaccountid);
                                        // getModalData(row?.PartyAccountID);
                                      }
                                    }}
                                  > */}
                                    {currencySymbol} {MoneyFormatv3(row.balancedueamount, 'en-IN')}
                                    {/* </a> */}
                                  </TableCell>

                                  <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} align="left" sx={{ whiteSpace: 'nowrap' }}>
                                    {row.duedate}
                                  </TableCell>
                                  <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} align="right">
                                    {row.statuscd === 'Paid' ? (
                                      '-'
                                    ) : (
                                      <span
                                        style={{
                                          color: row.cancelflag === 1 ? 'gray' : row.overduedays < 0 ? 'red' : 'green',
                                          opacity: row.cancelflag === 1 ? 0.5 : 1,
                                        }}
                                      >
                                        {Math.abs(row.overduedays)}&nbsp;
                                        {row.statuscd === 'Paid' ? '' : Math.abs(row.overduedays) == 1 ? 'day' : 'days'}
                                      </span>
                                    )}
                                  </TableCell>

                                  <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} align="left">
                                    {' '}
                                    {status}
                                  </TableCell>
                                  {getCompany?.relatedcompanydetailsnew?.[0]?.einvoiceflag == 1 ? (
                                    <TableCell sx={{ width: '100px' }} title={row.cancelflag === 1 ? 'Cancelled' : ''}>
                                      {row?.partygstcategory === 'UB' ? (
                                        <Typography sx={{ fontSize: '13px', textAlign: 'center', padding: '8px' }}>N/A</Typography>
                                      ) : row.cancelflag !== 1 && !row.irn ? (
                                        <Button
                                          variant="outlined"
                                          sx={{
                                            fontSize: '13px',
                                            whiteSpace: 'nowrap',
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleEInvoice(e, row.invoiceid);
                                          }}
                                        >
                                          Generate
                                        </Button>
                                      ) : row.irn && !row.is_cancelled && diff < 24 ? (
                                        <Button
                                          variant="outlined"
                                          sx={{
                                            whiteSpace: 'nowrap',
                                            paddingLeft: '8px',
                                            paddingRight: '8px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            lineHeight: 1.2,
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleCancelEIV(row);
                                          }}
                                        >
                                          <Box sx={{ fontSize: '12px' }}> Cancel EInv</Box>
                                          <Box sx={{ color: 'red', fontSize: '9px' }}>
                                            <TimeLeftComp startUnix={row?.einvoiceenteredtimestamp} />
                                          </Box>
                                        </Button>
                                      ) : row?.is_cancelled === 1 ? (
                                        <Box
                                          variant="inherit"
                                          sx={{
                                            color: row.cancelflag === 1 && 'gray',
                                            opacity: row.cancelflag === 1 ? 0.5 : 1,
                                            padding: '2px 8px',
                                            textAlign: 'center',
                                          }}
                                        >
                                          Cancelled
                                        </Box>
                                      ) : row.irn ? (
                                        <Typography
                                          sx={{
                                            color: row.cancelflag === 1 ? 'gray' : 'green',
                                            fontSize: '13px',
                                            textAlign: 'center',
                                            padding: '8px',
                                          }}
                                        >
                                          Active
                                        </Typography>
                                      ) : (
                                        ''
                                      )}
                                    </TableCell>
                                  ) : null}
                                  {/* {getCompany?.relatedcompanydetailsnew[0].einvoiceflag == 1 ? (
                                    <TableCell sx={{ width: '100px' }} title={row.cancelflag === 1 ? 'Cancelled' : ''}>
                                      {/* {row?.gstin !== "" ? ( 
                                      {diff > 24 || row?.cancelflag ? (
                                        <Typography sx={{ color: 'red' }}>{/* Cancel E-Invoice </Typography>
                                      ) : row?.is_cancelled === 1 ? (
                                        <Box
                                          variant="inherit"
                                          sx={{
                                            color: row.cancelflag === 1 ? 'gray' : 'red',
                                            opacity: row.cancelflag === 1 ? 0.5 : 1,
                                            padding: '2px 8px',
                                          }}
                                        >
                                          Cancelled
                                        </Box>
                                      ) : (
                                        row.irn &&
                                        row.cancelflag === 0 &&
                                        diff < 24 && (
                                          <Button
                                            variant="outlined"
                                            sx={{
                                              whiteSpace: 'nowrap',
                                              padding: '2px 8px',
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleCancelEIV(row);
                                            }}
                                          >
                                            Cancel
                                            <Typography 
                                              variant="caption" 
                                              sx={{ ml: 1, color: 'warning.main' }}
                                              data-time-left
                                              data-diff={diff}
                                              data-created-at={row.enteredtimestamp}
                                            >
                                              ({calculateTimeLeft(diff)} hrs)
                                            </Typography>
                                          </Button>
                                        )
                                      )}
                                    </TableCell>
                                  ) : null} */}
                                  {getCompany?.relatedcompanydetailsnew?.[0]?.ewaybillflag == 1 ? (
                                    <TableCell
                                      sx={{ width: '100px', padding: '0px!important' }}
                                      title={row.cancelflag === 1 ? 'Cancelled' : ''}
                                    >
                                      {row.goods_exist === 0 ? (
                                        <Typography sx={{ fontSize: '13px', padding: '8px', textAlign: 'center' }}>N/A</Typography>
                                      ) : !row?.ewaybillno && row.cancelflag !== 1 ? (
                                        <Button
                                          variant="outlined"
                                          sx={{
                                            whiteSpace: 'nowrap',
                                            // padding: '2px 8px',
                                            fontSize: '13px',
                                          }}
                                          onClick={(e) => {
                                            handleEWaybill(e, row);
                                            setActionData(row);
                                          }}
                                        >
                                          Generate
                                        </Button>
                                      ) : row.ewaybillno && !row?.ewaybill_is_cancelled && diffEway < 24 ? (
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                          {' '}
                                          <Button
                                            variant="outlined"
                                            sx={{
                                              whiteSpace: 'nowrap',
                                              paddingLeft: '8px',
                                              paddingRight: '8px',
                                              display: 'flex',
                                              flexDirection: 'column',
                                              alignItems: 'center',
                                              lineHeight: 1.2,
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleCancelEWay(row);
                                            }}
                                          >
                                            <Box sx={{ fontSize: '12px' }}> Cancel EWB</Box>
                                            <Box sx={{ color: 'red', fontSize: '8px' }}>
                                              <TimeLeftComp startUnix={row?.ewaybillenteredtimestamp} />
                                            </Box>
                                          </Button>
                                        </Stack>
                                      ) : row?.ewaybill_is_cancelled === 1 ? (
                                        <Box
                                          variant="inherit"
                                          sx={{
                                            color: row.cancelflag === 1 && 'gray',
                                            opacity: row.cancelflag === 1 ? 0.5 : 1,
                                            padding: '2px 8px',
                                            fontSize: '13px',
                                            textAlign: 'center',
                                          }}
                                        >
                                          Cancelled
                                        </Box>
                                      ) : !row?.ewaybill_is_cancelled ? (
                                        <Typography
                                          align="center"
                                          sx={{
                                            color: row.cancelflag === 1 ? 'gray' : row.ewaybillstatus === 'Active' && 'green',
                                            fontSize: '13px',
                                            padding: '8px',
                                          }}
                                        >
                                          {row.ewaybillstatus}
                                        </Typography>
                                      ) : null}
                                    </TableCell>
                                  ) : null}

                                  {getCompany?.relatedcompanydetailsnew?.[0]?.ewaybillflag == 1 ? (
                                    <TableCell
                                      sx={{
                                        width: '100px',
                                        padding: '0px!important',
                                      }}
                                      title={row.cancelflag === 1 ? 'Cancelled' : ''}
                                    >
                                      {row.ewaybillno && (
                                        <Tooltip title={'Download PDF'} placement="left" disableInteractive arrow>
                                          <IconButton
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.preventDefault();
                                              checkandopenpdf(row.ewaybillpdf);
                                            }}
                                            aria-label="delete"
                                            sx={{
                                              margin: '0px 2px',
                                              padding: '5px',
                                              backgroundColor: '#c5d6dc',
                                              border: 'solid 1px black',
                                            }}
                                          >
                                            <img src={pdfImage} height={10} alt="Download" />
                                          </IconButton>
                                        </Tooltip>
                                      )}
                                    </TableCell>
                                  ) : null}

                                  {/*  {getCompany?.relatedcompanydetailsnew?.[0]?.ewaybillflag == 1 ? (
                                    <TableCell sx={{ width: '100px' }} title={row.cancelflag === 1 ? 'Cancelled' : ''}>
                                      <Box
                                        variant="inherit"
                                        sx={{
                                          color: row.cancelflag === 1 && 'gray',
                                          opacity: row.cancelflag === 1 ? 0.5 : 1,
                                          // padding: '2px 8px',
                                        }}
                                      >
                                        {row?.ewaybillstatus}
                                      </Box>
                                    </TableCell>
                                  ) : null} */}
                                  {/* <TableCell align="left">
                                <a
                                  underline="hover"
                                  style={{
                                    color: theme.palette.text.Link, 
                                    cursor: "pointer",
                                  }}
                                  href={`/viewLedger?id=${row?.PartyAccountID}&&name=${row?.PartyDisplayName}&&page=/salesInvoiceReport`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if (
                                      row?.PartyAccountID !== ""
                                    ) {
                                      setBackdropOpen(true);
                                      setAccountName(
                                        row?.PartyDisplayName
                                      );
                                      setAccountID(
                                        row?.PartyAccountID
                                      );
                                      getModalData(
                                        row?.PartyAccountID
                                      );
                                    }
                                  }}
                                >
                                  {" "}
                                  {MoneyFormatv3(row.BalanceDueAmount)}
                                </a>
                              </TableCell> */}

                                  <TableCell
                                    className="actionBackGround"
                                    align="center"
                                    id="actionDeatils"
                                    sx={{ position: !showActions ? 'relative' : 'sticky' }}
                                  >
                                    <Box className="actionCellStyle">
                                      <Tooltip title={'Download PDF'} placement="left" disableInteractive arrow>
                                        <IconButton
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            checkandopenpdf(row.invoicepdf);
                                          }}
                                          aria-label="delete"
                                          sx={{
                                            margin: '0px 2px',
                                            padding: '5px',
                                            backgroundColor: '#c5d6dc',
                                            border: 'solid 1px black',
                                          }}
                                        >
                                          <img src={pdfImage} height={10} alt="Download" />
                                        </IconButton>
                                      </Tooltip>
                                      <Tooltip title={'Print'} placement="left" disableInteractive arrow>
                                        <IconButton
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            fetchAndPrintPDF(row.invoicepdf);
                                            // printInvoice(row);
                                          }}
                                          aria-label="delete"
                                          sx={{
                                            margin: '0px 2px',
                                            padding: '5px',
                                            backgroundColor: '#c5d6dc',
                                            border: 'solid 1px black',
                                          }}
                                        >
                                          <Print
                                            sx={{
                                              fontSize: '10px',
                                              color: '#36454f',
                                            }}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                      {/* {row.expiredtimestamp === 0 && row.cancelflag == 0 ? ( */}
                                      <Tooltip
                                        title={row.cancelflag === 0 ? 'Edit' : 'cannot Edit'}
                                        placement="right"
                                        disableInteractive
                                        arrow
                                      >
                                        <IconButton
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            if (Freeze == 1) {
                                              return handleFreeze();
                                            }
                                            if (row.expiredtimestamp === 0 && row.cancelflag == 1) {
                                              return;
                                            }
                                            dispatch(updateTitle(row.invoicenumber));

                                            navigate('/editnewinvoicetax', {
                                              state: {
                                                id: row.invoiceid,
                                                pdflink: row.invoicepdf,
                                                irn: row?.irn,
                                                view: false,
                                              },
                                            });
                                          }}
                                          aria-label="delete"
                                          sx={{
                                            margin: '0px 2px',
                                            padding: '5px',
                                            backgroundColor: '#D0EFFF',
                                            border: 'solid 1px black',
                                          }}
                                        >
                                          {row.expiredtimestamp === 0 && row.cancelflag == 0 ? (
                                            <Edit
                                              sx={{
                                                fontSize: '10px',
                                                color: '#6096d9',
                                              }}
                                            />
                                          ) : (
                                            <EditOff sx={{ fontSize: '10px', color: '#6096d9' }} />
                                          )}
                                        </IconButton>
                                      </Tooltip>
                                      {/* ) : null} */}
                                      <Tooltip title={'Share'} placement="left" disableInteractive arrow>
                                        <IconButton
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            // For individual Share, use separate state
                                            // that doesn't interfere with bulk selection
                                            setIndividualEmailSelection([
                                              {
                                                PartyID: row?.partyid,
                                                Email: row?.partyemail,
                                                PartyDisplayName: row?.partydisplayname,
                                                invoiceid: row.invoiceid,
                                                invoicenumber: row?.invoicenumber,
                                              },
                                            ]);
                                            setShareOpen(row.invoicepdf, true);
                                          }}
                                          aria-label="delete"
                                          sx={{
                                            margin: '0px 2px',
                                            padding: '5px',
                                            backgroundColor: '#E8F5E9',
                                            border: 'solid 1px black',
                                            // backgroundColor: '#b1d1f97d'
                                          }}
                                        >
                                          <Share
                                            sx={{
                                              fontSize: '10px',
                                              color: '#388E3C',
                                              // color: '#6096d9'
                                            }}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                      {/* <ThreeDot
                                    onPrint={(e) => {
                                      printInvoice(row);
                                    }}
                                    onView={(e) => {
                                      e.stopPropagation();
                                      dispatch(updateTitle(row.InvoiceNumber));
                                      if (
                                        row.InvoiceTaxableTypeCD == "TAXABLE"
                                      ) {
                                        navigate(
                                          // "/viewinvoiceTaxable",
                                          "/viewnewinvoicetax",
                                          {
                                            state: {
                                              id: row.InvoiceID,
                                              view: true,
                                            },
                                          }
                                        );
                                      } else if (
                                        row.InvoiceTaxableTypeCD ==
                                        "NON-TAXABLE"
                                      ) {
                                        navigate("/viewnewinvoicetax", {
                                          state: {
                                            id: row.InvoiceID,
                                            view: true,
                                          },
                                        });
                                      }
                                    }}
                                    onDelete={
                                      row.ExpiredTimeStamp === 0
                                        ? (e) => {
                                          e.stopPropagation();
                                          setDeleteModalStatus(true);
                                          setItemData({
                                            id: row.InvoiceID,
                                            ind: index,
                                          });
                                        }
                                        : ""
                                    }
                                    onEdit={
                                      row.ExpiredTimeStamp === 0 &&
                                        row.CancelFlag == 0
                                        ? (e) => {
                                          e.stopPropagation();
                                          dispatch(
                                            updateTitle(row.InvoiceNumber)
                                          );
                                          if (
                                            row.InvoiceTaxableTypeCD ==
                                            "TAXABLE"
                                          ) {
                                            navigate("/editnewinvoicetax", {
                                              state: { id: row.InvoiceID },
                                            });
                                          } else if (
                                            row.InvoiceTaxableTypeCD ==
                                            "NON-TAXABLE"
                                          ) {
                                            navigate("/editnewinvoicetax", {
                                              state: { id: row.InvoiceID },
                                            });
                                          }
                                        }
                                        : ""
                                    }
                                    onCancel={
                                      row.ExpiredTimeStamp != 0 ||
                                        row.CancelFlag == 1
                                        ? null
                                        : (event) => {
                                          event.stopPropagation();
                                          dispatch(
                                            updateTitle(row.CrDrNoteNumber)
                                          );
                                          setWarningOpen({
                                            render: (
                                              <Box>
                                                <Typography>
                                                  Are you sure you want to
                                                  cancel this Invoice ?
                                                </Typography>
                                                <Typography
                                                  component={"p"}
                                                  sx={{ fontSize: "smaller" }}
                                                >
                                                  <br />
                                                  <b>
                                                    NOTE : All the payments
                                                    linked with this invoice
                                                    will be cancelled
                                                    immediately.
                                                    <br />
                                                    You can't undo this
                                                    action.
                                                  </b>
                                                </Typography>
                                                <Box
                                                  sx={{ marginTop: "8px" }}
                                                >
                                                  <TeaxtareaField
                                                    name="reason"
                                                    placeholder="Reason for Cancellation"
                                                    size="small"
                                                    fullWidth
                                                    rows={6}
                                                    state={state}
                                                    // value={state.reason}
                                                    onChange={(e) => {
                                                      console.log(
                                                        e.target.value
                                                      );
                                                      if (
                                                        e.target.value
                                                          .length > 250
                                                      ) {
                                                        setState((prev) => ({
                                                          ...prev,
                                                          ["reason"]:
                                                            e.target.value,
                                                          ["errorStatus"]: {
                                                            ...prev.errorStatus,
                                                            ["reason"]: true,
                                                          },
                                                          ["errorFields"]: {
                                                            ...prev.errorFields,
                                                            ["reason"]:
                                                              "Reason for Cancellation must be less than 250 characters",
                                                          },
                                                        }));
                                                      } else if (
                                                        e.target.value
                                                          .length <= 0
                                                      ) {
                                                        setState((prev) => ({
                                                          ...prev,
                                                          ["reason"]:
                                                            e.target.value,
                                                          ["errorStatus"]: {
                                                            ...prev.errorStatus,
                                                            ["reason"]: true,
                                                          },
                                                          ["errorFields"]: {
                                                            ...prev.errorFields,
                                                            ["reason"]:
                                                              "Reason for Cancellation is Required",
                                                          },
                                                        }));
                                                      } else {
                                                        console.log(
                                                          e.target.value
                                                        );
                                                        setState((prev) => ({
                                                          ...prev,
                                                          reason:
                                                            e.target.value,
                                                          ["errorStatus"]: {
                                                            ...prev.errorStatus,
                                                            ["reason"]: false,
                                                          },
                                                          ["errorFields"]: {
                                                            ...prev.errorFields,
                                                            ["reason"]: "",
                                                          },
                                                        }));
                                                      }
                                                    }}
                                                  />
                                                </Box>
                                              </Box>
                                            ),
                                            onContinue: async () => {
                                              await cancel(
                                                row.InvoiceID,
                                                state.reason
                                              );
                                            },
                                            onCancel: () => {
                                              setState((prev) => ({
                                                ...prev,
                                                reason: "",
                                                ["errorStatus"]: {
                                                  ...prev.errorStatus,
                                                  ["reason"]: false,
                                                },
                                                ["errorFields"]: {
                                                  ...prev.errorFields,
                                                  ["reason"]: "",
                                                },
                                              }));
                                            },
                                          });
                                        }
                                    }
                                  ></ThreeDot> */}
                                    </Box>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        minWidth: '150px',
                                      }}
                                    >
                                      {row.cancelflag !== 1 && row.statuscd !== 'Paid' && (
                                        <Button
                                          disabled={row.paymentclearedflag === 1 && row.statuscd !== 'Partial' ? true : false}
                                          variant="contained"
                                          size="small"
                                          sx={{
                                            fontSize: '10px',
                                            boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            if (Freeze == 1) {
                                              return handleFreeze();
                                            }
                                            navigate('/addreceipts', {
                                              state: {
                                                name: row?.partydisplayname,
                                                partyID: row.partyaccountid,
                                                invoiceNumber: row.invoicenumber,
                                              },
                                            });
                                          }}
                                        >
                                          RECORD RECEIPT
                                        </Button>
                                      )}
                                    </Box>
                                  </TableCell>
                                  {isLocal == true && (
                                    <TableCell>
                                      <button
                                        onClick={() => {
                                          generatePDF(0, row.invoiceid);
                                        }}
                                      >
                                        generate
                                      </button>
                                    </TableCell>
                                  )}
                                </TableRow>
                              );
                            })
                        ) : circularOpen == false && invoiceRows?.length <= 0 && !dataCount > 0 ? (
                          <>
                            <TableRow>
                              <TableCell height={'400'} align="center" colSpan={9} sx={{ border: 'none' }}>
                                No Data Found
                              </TableCell>
                            </TableRow>
                          </>
                        ) : (
                          ''
                        )}
                        {circularOpen == true &&
                          limit > 0 &&
                          Array.from({ length: limit }, (_, index) => (
                            <TableRow key={index}>
                              <TableCell colSpan={12}>
                                <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {dataCount > 0 && (
                    <TablePagination
                      // rowsPerPageOptions={[5, 10, 25,{ label: 'All', value: -1 }]}
                      rowsPerPageOptions={defaultRowsPerPageOptions}
                      component="div"
                      count={dataCount}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  )}
                </Box>
              )}
            </>
          )}
          {/* Invoice Sales Table */}
        </Box>
      </>
      <CancelInvoice
        open={cancelModalStatus}
        setOpen={setCancelModalStatus}
        itemData={itemData}
        rows={invoiceRows}
        setRows={setInvoiceROws}
        listInvoices={listInvoices}
        // listPos={listPos}
      />
      <DeleteInvoice
        open={deleteModalStatus}
        setOpen={setDeleteModalStatus}
        itemData={itemData}
        rows={invoiceRows}
        setRows={setInvoiceROws}
        listInvoices={listInvoices}
        // listPos={listPos}
      />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <ExportData
        setOpen={setExportModalOpen}
        open={exportModalOpen}
        item={exportItem}
      /> */}
      {shareOpen ? (
        <ShareModal
          open={shareOpen}
          emailData={{
            selectedRow: individualEmailSelection?.map((inv) => ({
              id: Number(inv.invoiceid),
              recipientId: Number(inv.PartyID),
              email: inv.Email,
              name: inv.PartyDisplayName,
              invoiceNumber: inv.invoicenumber,
            })),
            type: 'salesInvoice',
          }}
          setOpen={setShareOpen}
        />
      ) : null}{' '}
      <DeletedSelectedInvoice
        open={deleteSelectedModal}
        setOpen={setDeleteSelectedModal}
        // rows={filteredList}
        // setRows={setFilteredList}
        itemsData={selected}
        listInvoices={listInvoices}
      />
      {WarningModal}
      {accountID && <LedgerTransactionModalv2 open={accountID} accountId={accountID} onClose={() => setAccountID('')} />}
      <PreviewSalesTaxable
        setBackdropOpen={setBackdropOpen}
        ref={modalRef}
        path={path}
        allsalesfn={(id, irn) => {
          setInvoiceROws((currentItems) => {
            return currentItems.map((item) =>
              item.invoiceid === id
                ? {
                    ...item,
                    einvoiceenteredtimestamp: dayjs().unix(),
                    irn,
                    new: true,
                  }
                : { ...item }
            );
          });
        }}
      />
      <EInvAuth
        open={cancelEOpen}
        checkbox={connectCheckbox}
        setOpen={setCancelEOpen}
        allSales={true}
        action={() => {
          console.log(connectCheckbox, 'connectCheckbox');
          if (action === 'geneway') {
            ewayNav(actionData);
          } else if (connectCheckbox.includes('eway')) {
            setCancelEInv(true);
          }
        }}
        setCancelEInv={setCancelEInv}
        authOk={() => {
          // if (modalRef.current) {
          setBackdropOpen(true);
          modalRef.current.triggerCustomAction(rowData.id);
          setBackdropOpen(false);
          // }
        }}
        rowData={rowData}
      />
      {cancelEInv ? (
        <EInvoiceCancel
          state={cancelEInvState}
          setState={setCancelEInvState}
          open={cancelEInv}
          backdropOpen={backdropOpen}
          handleEINVBlur={handleEINVBlur}
          handleInputChange={handleInputChange}
          setOpen={setCancelEInv}
          itemData={rowData}
          cancelEINV={rowData.from === 'E-Way' ? handleCancelEWaybill : cancelEInvoice}
        />
      ) : null}
      <SendEmailModalWrapper {...modalProps} />
    </Box>
  );
}

export default AllSalesInvoices;
